import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { IsOpen } from '../../../components/Icon';
import { fetchInvoice } from '../../Invoices/actions';
import { getPropByName } from '../../../utils/props';
import { formatCurrency } from '../../../utils/string';
import { VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW, VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_MARGE } from '../constants';
import { fetchUser } from '../../Users/actions';
import { selectWork } from '../../Api/selectors';
import { REQUEST_USER } from '../../Users/constants';
import { selectUser } from '../../Users/selectors';
import { Loader } from 'react-feather';
import { AiOutlineInfoCircle, AiFillCheckCircle } from 'react-icons/ai';
import { BsHourglassBottom } from 'react-icons/bs';
import cn from 'classnames';
import styles from './CardCounters.module.css';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }

  .cell-value {
    white-space: nowrap;
  }
`;

<BsHourglassBottom style={{ fontSize: '32px' }} />;

const STATE = {
  isOpen: false,
  incomingInvoice: null,
  userBuyer: null,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCardCountersComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  render() {
    const vehicle = this.props.vehicle;

    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container>
          <HBox>
            <h2 className="card-title mb-0 text-muted">{this.lbl('vehicle.info.finance.purchase.counters')}</h2>
            <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
              <IsOpen />
            </div>
          </HBox>
          {this.state.isOpen && (
            <List>
              <Row className={styles.row}>
                <Cell className={styles.cell1}>
                  <span title="Inkomende factuur verwerkt tot uitgaande factuur verwerkt">
                    {this.lbl('vehicle.info.finance.purchase.counters.finance_standingdays')}
                  </span>
                </Cell>
                <Cell className={styles.cell2}>
                  {vehicle.incoming_invoice_finalized_date
                    ? vehicle?.financestadagen
                    : this.lbl('vehicle.info.finance.purchase.counters.no_incoming_invoice_finalized')}
                  {!vehicle.outgoing_invoice_finalized_date && vehicle.incoming_invoice_finalized_date ? (
                    <span style={{ fontSize: '16px' }} title="In behandeling">
                      <BsHourglassBottom />
                    </span>
                  ) : vehicle.outgoing_invoice_finalized_date ? (
                    <span style={{ fontSize: '16px' }} title="Afgerond">
                      <AiFillCheckCircle />
                    </span>
                  ) : (
                    ''
                  )}
                </Cell>
              </Row>
              <Row className={styles.row}>
                <Cell className={styles.cell1}>
                  <span title="Inspectie tot uitgaande factuur verwerkt">
                    {this.lbl('vehicle.info.finance.purchase.counters.commercial_standingdays')}
                  </span>
                </Cell>
                <Cell className={styles.cell2}>
                  {vehicle.inspection_done_date
                    ? vehicle?.inspecteren
                    : this.lbl('vehicle.info.finance.purchase.counters.inspectie')}
                  {!vehicle.outgoing_invoice_finalized_date && vehicle.inspection_done_date ? (
                    <span style={{ fontSize: '16px' }} title="In behandeling">
                      <BsHourglassBottom />
                    </span>
                  ) : vehicle.outgoing_invoice_finalized_date ? (
                    <span style={{ fontSize: '16px' }} title="Afgerond">
                      <AiFillCheckCircle />
                    </span>
                  ) : (
                    ''
                  )}
                </Cell>
              </Row>

              <Row className={styles.row}>
                <Cell className={styles.cell1}>
                  <span title="Geadverteerd tot uitgaande factuur verwerkt">
                    {this.lbl('vehicle.info.finance.purchase.counters.advertised')}
                  </span>
                </Cell>
                <Cell className={styles.cell2}>
                  {vehicle.show_on_sales_website_date
                    ? vehicle?.advertised
                    : this.lbl('vehicle.info.finance.purchase.counters.not_advertised')}
                  {!vehicle.outgoing_invoice_finalized_date && vehicle.show_on_sales_website_date ? (
                    <span style={{ fontSize: '16px' }} title="In behandeling">
                      <BsHourglassBottom />
                    </span>
                  ) : vehicle.outgoing_invoice_finalized_date ? (
                    <span style={{ fontSize: '16px' }} title="Afgerond">
                      <AiFillCheckCircle />
                    </span>
                  ) : (
                    ''
                  )}
                </Cell>
              </Row>
              <Row className={styles.row}>
                <Cell className={styles.cell1}>
                  <span title="Uitgaande factuur verwerkt tot klaargezet voor vrijwaring">
                    {this.lbl('vehicle.info.finance.purchase.counters.verkoop_vrijwaren_doorlooptijd')}
                  </span>
                </Cell>
                <Cell className={styles.cell2}>
                  {vehicle.outgoing_invoice_finalized_date
                    ? vehicle?.verkoopvrijwarendoorlooptijd_counter
                    : this.lbl('vehicle.info.finance.purchase.counters.no_outgoing_invoice_finalized')}
                  {!vehicle.sales_release_done_date && vehicle.outgoing_invoice_finalized_date ? (
                    <span style={{ fontSize: '16px' }} title="In behandeling">
                      <BsHourglassBottom />
                    </span>
                  ) : vehicle.sales_release_done_date ? (
                    <span style={{ fontSize: '16px' }} title="Afgerond">
                      <AiFillCheckCircle />
                    </span>
                  ) : (
                    ''
                  )}
                </Cell>
              </Row>

              <Row className={styles.row}>
                <Cell className={styles.cell1}>
                  <span title="Klaar voor import tot import gereed">
                    {this.lbl('vehicle.info.finance.purchase.counters.importadminstratie')}
                  </span>
                </Cell>
                <Cell className={styles.cell2}>
                  {vehicle.sell_with_license_plate_date &&
                  vehicle.document_regplate_foreign_date &&
                  vehicle.inspection_done_date
                    ? vehicle?.importadministration
                    : this.lbl('vehicle.info.finance.purchase.counters.not_complete_for_import')}
                  {!vehicle.bvi_done_date &&
                  vehicle.sell_with_license_plate_date &&
                  vehicle.document_regplate_foreign_date &&
                  vehicle.inspection_done_date ? (
                    <span style={{ fontSize: '16px' }} title="In behandeling">
                      <BsHourglassBottom />
                    </span>
                  ) : vehicle.bvi_done_date ? (
                    <span style={{ fontSize: '16px' }} title="Afgerond">
                      <AiFillCheckCircle />
                    </span>
                  ) : (
                    ''
                  )}
                </Cell>
              </Row>

              <Row className={styles.row}>
                <Cell className={styles.cell1}>
                  <span title="Inkomende factuur verwerkt tot buitenlands kenteken toegevoegd">
                    {this.lbl('vehicle.info.finance.purchase.counters.regplate_foreign')}
                  </span>
                </Cell>
                <Cell className={styles.cell2}>
                  {vehicle.incoming_invoice_finalized_date
                    ? vehicle?.request_regplate_foreign
                    : this.lbl('vehicle.info.finance.purchase.counters.inkoopfactuur niet verwerkt')}
                  {/* {!vehicle.bvi_done_date && vehicle.sell_with_license_plate_date && vehicle.document_regplate_foreign_date && vehicle.inspection_done_date ? (
                        <span style={{ fontSize: '16px' }} title="In behandeling">
                          <BsHourglassBottom />
                        </span>
                      ) : vehicle.bvi_done_date ? (
                        <span style={{ fontSize: '16px' }} title="Afgerond">
                          <AiFillCheckCircle />
                        </span>
                      ) : (
                        ""
                      )} */}
                </Cell>
              </Row>

              <Row className={styles.row}>
                <Cell className={styles.cell1}>
                  <span title="Aanmaken voertuig tot inkoopvrijwaren">
                    {this.lbl('vehicle.info.finance.purchase.counters.inkoop_vrijwaren')}
                  </span>
                </Cell>
                <Cell className={styles.cell2}>
                  {vehicle.createdAt
                    ? vehicle?.inkoopadministratie
                    : this.lbl('vehicle.info.finance.purchase.counters.not_yet_possible')}
                  {!vehicle.createdAt ? (
                    <span style={{ fontSize: '16px' }} title="In behandeling">
                      <BsHourglassBottom />
                    </span>
                  ) : vehicle.purchase_release_done_date ? (
                    <span style={{ fontSize: '16px' }} title="Afgerond">
                      <AiFillCheckCircle />
                    </span>
                  ) : (
                    ''
                  )}
                </Cell>
              </Row>
              {/* wallstreet */}

              {!vehicle.labels_done_date ? (
                <Row className={styles.row}>
                  <Cell className={styles.cell1}>
                    <span title="Doorlooptijd Walstreet">
                      {this.lbl('vehicle.info.finance.purchase.counters.walstreet')}
                    </span>
                  </Cell>
                  <Cell className={styles.cell2}>{this.lbl('vehicle.info.finance.purchase.counters.not_labelled')}</Cell>
                </Row>
              ) : !vehicle.dont_fix_damages && !vehicle.fix_damages ? (
                <Row className={styles.row}>
                  <Cell className={styles.cell1}>
                    <span title="Walstreet, gelabeld tot inspectie (Geen verkoopvoorkeur)">
                      {this.lbl('vehicle.info.finance.purchase.counters.no_sales_pref')}
                    </span>
                  </Cell>
                  <Cell className={styles.cell2}>
                    {vehicle?.walstreetdoorlooptijddontfix} {!vehicle.inspection_done_date ? 'Wacht op inspectie' : ''}
                    {!vehicle.inspection_done_date && vehicle.labels_done_date ? (
                      <span style={{ fontSize: '16px' }} title="In behandeling">
                        <BsHourglassBottom />
                      </span>
                    ) : vehicle.inspection_done_date ? (
                      <span style={{ fontSize: '16px' }} title="Afgerond">
                        <AiFillCheckCircle />
                      </span>
                    ) : (
                      ''
                    )}
                  </Cell>
                </Row>
              ) : vehicle.dont_fix_damages === '1' ? (
                <Row className={styles.row}>
                  <Cell className={styles.cell1}>
                    <span title="Walstreet, gelabeld tot inspectie (Geen schade repareren)">
                      {this.lbl('vehicle.info.finance.purchase.counters.dont_fix_damages')}
                    </span>
                  </Cell>
                  <Cell className={styles.cell2}>
                    {vehicle?.walstreetdoorlooptijddontfix} {!vehicle.inspection_done_date ? 'Wacht op inspectie' : ''}
                    {!vehicle.inspection_done_date && vehicle.labels_done_date ? (
                      <span style={{ fontSize: '16px' }} title="In behandeling">
                        <BsHourglassBottom />
                      </span>
                    ) : vehicle.inspection_done_date ? (
                      <span style={{ fontSize: '16px' }} title="Afgerond">
                        <AiFillCheckCircle />
                      </span>
                    ) : (
                      ''
                    )}
                  </Cell>
                </Row>
              ) : vehicle.fix_damages === '1' ? (
                <Row className={styles.row}>
                  <Cell className={styles.cell1}>
                    <span title="Walstreet, gelabeld tot Eindinspectie (Schade repareren)">
                      {this.lbl('vehicle.info.finance.purchase.counters.fix_damages')}
                    </span>
                  </Cell>
                  <Cell className={styles.cell2}>
                    {vehicle?.walstreetdoorlooptijdfix} {!vehicle.inspection_done_date ? 'Wacht op inspectie' : ''}
                    {!vehicle.task_final_inspection_done_date && vehicle.labels_done_date ? (
                      <span style={{ fontSize: '16px' }} title="In behandeling">
                        <BsHourglassBottom />
                      </span>
                    ) : vehicle.task_final_inspection_done_date ? (
                      <span style={{ fontSize: '16px' }} title="Afgerond">
                        <AiFillCheckCircle />
                      </span>
                    ) : (
                      ''
                    )}
                  </Cell>
                </Row>
              ) : (
                <Row className={styles.row}>
                  <Cell className={styles.cell1}>{this.lbl('vehicle.info.finance.purchase.counters.inspectie')}</Cell>
                  <Cell className={styles.cell2}>{vehicle?.walstreetdoorlooptijddontfix}</Cell>
                </Row>
              )}

              {vehicle.transport_outgoing_assigned_to === '1' ? (
                <>
                  <Row className={styles.row}>
                    <Cell className={styles.cell1}>
                      <span title="Uitgaande factuur verwerkt tot uitgaand transport afgerond">
                        {this.lbl('vehicle.info.finance.purchase.counters.transport_outgoing_extern')}
                      </span>
                    </Cell>
                    <Cell className={styles.cell2}>
                      {vehicle.outgoing_invoice_finalized_date
                        ? vehicle?.transportuitgaandextern
                        : this.lbl('vehicle.info.finance.purchase.counters.no_outgoing_invoice_finalized')}
                      {!vehicle.transport_outgoing_completed_date && vehicle.outgoing_invoice_finalized_date ? (
                        <span style={{ fontSize: '16px' }} title="In behandeling">
                          <BsHourglassBottom />
                        </span>
                      ) : vehicle.transport_outgoing_completed_date ? (
                        <span style={{ fontSize: '16px' }} title="Afgerond">
                          <AiFillCheckCircle />
                        </span>
                      ) : (
                        ''
                      )}
                    </Cell>
                  </Row>
                </>
              ) : (
                ''
              )}
              {vehicle.transport_outgoing_requested &&
              (vehicle.transport_outgoing_assigned_to !== '1' || !vehicle.transport_outgoing_assigned_to) ? (
                <>
                  <Row className={styles.row}>
                    <Cell className={styles.cell1}>
                      <span title="Uitgaande factuur verwerkt tot uitgaand transport afgerond">
                        {this.lbl('vehicle.info.finance.purchase.counters.transport_outgoing_intern')}
                      </span>
                    </Cell>
                    <Cell className={styles.cell2}>
                      {vehicle.outgoing_invoice_finalized_date
                        ? vehicle?.transportuitgaandintern
                        : this.lbl('vehicle.info.finance.purchase.counters.no_outgoing_invoice_finalized')}
                      {!vehicle.transport_outgoing_completed_date && vehicle.outgoing_invoice_finalized_date ? (
                        <span style={{ fontSize: '16px' }} title="In behandeling">
                          <BsHourglassBottom />
                        </span>
                      ) : vehicle.transport_outgoing_completed_date ? (
                        <span style={{ fontSize: '16px' }} title="Afgerond">
                          <AiFillCheckCircle />
                        </span>
                      ) : (
                        ''
                      )}
                    </Cell>
                  </Row>
                </>
              ) : (
                ''
              )}
              {vehicle.transport_outgoing_requested && !vehicle.transport_outgoing_assigned_to ? (
                <>
                  <Row className={styles.row}>
                    <Cell className={styles.cell1}>
                      <span title="Uitgaande factuur verwerkt tot uitgaand transport afgerond">
                        {this.lbl('vehicle.info.finance.purchase.counters.transport_outgoing_intern')}
                      </span>
                    </Cell>
                    <Cell className={styles.cell2}>
                      {vehicle.outgoing_invoice_finalized_date
                        ? vehicle?.transportuitgaandintern
                        : this.lbl('vehicle.info.finance.purchase.counters.no_outgoing_invoice_finalized')}
                      {!vehicle.transport_outgoing_completed_date && vehicle.outgoing_invoice_finalized_date ? (
                        <span style={{ fontSize: '16px' }} title="In behandeling">
                          <BsHourglassBottom />
                        </span>
                      ) : vehicle.transport_outgoing_completed_date ? (
                        <span style={{ fontSize: '16px' }} title="Afgerond">
                          <AiFillCheckCircle />
                        </span>
                      ) : (
                        ''
                      )}
                    </Cell>
                  </Row>
                </>
              ) : (
                ''
              )}

              {(vehicle.transport === 'pickup' || vehicle.transport === 'anders') && vehicle.import === '0' ? (
                <>
                  <Row className={styles.row}>
                    <Cell className={styles.cell1}>
                      <span title="Inkomend transport te plannen tot transport afgerond">
                        {this.lbl('vehicle.info.finance.purchase.counters.transport_incoming')}
                      </span>
                    </Cell>
                    <Cell className={styles.cell2}>
                      {vehicle.transport_incoming_to_be_planned_date
                        ? vehicle?.transportinkomend
                        : this.lbl('vehicle.info.finance.purchase.counters.transport_incoming_to_be_planned')}
                      {!vehicle.transport_incoming_completed_date && vehicle.transport_incoming_to_be_planned_date ? (
                        <span style={{ fontSize: '16px' }} title="In behandeling">
                          <BsHourglassBottom />
                        </span>
                      ) : vehicle.transport_incoming_completed_date ? (
                        <span style={{ fontSize: '16px' }} title="Afgerond">
                          <AiFillCheckCircle />
                        </span>
                      ) : (
                        ''
                      )}
                    </Cell>
                  </Row>
                </>
              ) : (
                ''
              )}
              {(vehicle.transport === 'pickup' || vehicle.transport === 'anders') && vehicle.import === '1' ? (
                <>
                  <Row className={styles.row}>
                    <Cell className={styles.cell1}>
                      <span title="Inkomend transport te plannen tot transport afgerond">
                        {this.lbl('vehicle.info.finance.purchase.counters.transport_incoming')}
                      </span>
                    </Cell>
                    <Cell className={styles.cell2}>
                      {vehicle.incoming_invoice_finalized
                        ? vehicle?.transportinkomendimport
                        : this.lbl('vehicle.info.finance.purchase.counters.transport_import')}
                      {!vehicle.labels_done_date && vehicle.incoming_invoice_finalized ? (
                        <span style={{ fontSize: '16px' }} title="In behandeling">
                          <BsHourglassBottom />
                        </span>
                      ) : vehicle.labels_done_date ? (
                        <span style={{ fontSize: '16px' }} title="Afgerond">
                          <AiFillCheckCircle />
                        </span>
                      ) : (
                        ''
                      )}
                    </Cell>
                  </Row>
                </>
              ) : (
                ''
              )}
            </List>
          )}
        </Container>
      </Card>
    );
  }
}

VehicleCardCountersComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workUser: selectWork(REQUEST_USER),
    userBuyer: selectUser(ownProps.vehicle?.user_buyer_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(invoiceId, callback) {
      dispatch(fetchInvoice(invoiceId, callback));
    },
    fetchUser(userId, callback) {
      dispatch(fetchUser(userId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCardCounters = compose(withConnect, withRouter)(VehicleCardCountersComp);
